import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface SettingsState {
  reloadRequired: boolean;
  widgetIsOpen: Record<string, boolean>;
}

const initialState: SettingsState = {
  reloadRequired: false,
  widgetIsOpen: {},
};

export type WidgetIsOpenPayloadType = {
  contentType: 'procedure' | 'policy' | 'accountprofile';
  objectId: string | number;
  widgetName: string;
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setReloadRequired: (state, action: PayloadAction<boolean>) => {
      state.reloadRequired = action.payload;
    },
    toggleWidgetIsOpen: (
      state,
      action: PayloadAction<WidgetIsOpenPayloadType>
    ) => {
      const {contentType, objectId, widgetName} = action.payload;
      const key = `${contentType} ${objectId} ${widgetName}`;
      state.widgetIsOpen[key] = !(state.widgetIsOpen[key] ?? true);
    },
  },
});

export const {setReloadRequired, toggleWidgetIsOpen} = settingsSlice.actions;

export const settingsReducer = settingsSlice.reducer;
